import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  min-height: 40px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
`;

export const SelectContainer = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
`;

export const SelectInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.white};
  height: 40px;
  box-sizing: border-box;
  font-size: 1rem;
  width: 100%;

  &:focus-within {
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.defaultColorShadow};
  }
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  font-size: 14px;
  padding: 0;
  height: 100%;
  font-family: inherit;
  color: ${({ theme }) => theme.textColor};
`;

export const OptionsContainer = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 2px;
  max-height: ${({ isOpen }) => (isOpen ? '200px' : '0')};
  height: auto;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.backgroundColor};
  border: ${({ isOpen, theme }) => (isOpen ? `1px solid ${theme.borderColor}` : '0')};
  border-radius: 4px;
  z-index: 10;
  transition: max-height 0.3s ease, opacity 0.2s ease;
  box-shadow: ${({ isOpen }) => (isOpen ? '0 2px 8px rgba(0, 0, 0, 0.15)' : 'none')};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  width: 100%;
`;

export const Option = styled.div<{ isSelected: boolean; isHighlighted?: boolean }>`
  padding: 10px;
  cursor: pointer;
  background-color: ${({ isSelected, isHighlighted, theme }) => {
    if (isSelected) return theme.backgroundColor;
    if (isHighlighted) return theme.backgroundColor;
    return theme.backgroundColor;
  }};
  border-left: ${({ isHighlighted, theme }) => (isHighlighted ? `3px solid ${theme.primaryColor}` : `3px solid ${theme.backgroundColor}`)};
  color: ${({ theme }) => theme.textColor};

  &:hover {
    background-color: ${({ theme }) => theme.lightGrayColor};
  }
`;

export const Placeholder = styled.div`
  color: ${({ theme }) => theme.darkGray};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectedValue = styled.div`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 8px;
  color: ${({ theme }) => theme.textColor};
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  margin-left: 8px;
  flex-shrink: 0;
  width: 12px;
  color: ${({ theme }) => theme.textColor};
`;

export const NoOptions = styled.div`
  padding: 10px;
  color: ${({ theme }) => theme.darkGray};
  text-align: center;
`;
